export const district_data = {
  "Alabama": [
    {
      "district": "AL-1",
      "seat_type": "U.S. Representative",
      "state": "Alabama",
      "county": "Jefferson County",
      "population": 500000,
      "notes": "Competitive district in central Alabama."
    },
    {
      "district": "AL-2",
      "seat_type": "U.S. Representative",
      "state": "Alabama",
      "county": "Mobile County",
      "population": 450000,
      "notes": "Competitive district in southern Alabama."
    }
  ],
  "Alaska": [
    {
      "district": "AK-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Alaska",
      "county": "Anchorage Municipality",
      "population": 300000,
      "notes": "Statewide at-large district."
    }
  ],
  "Arizona": [
    {
      "district": "AZ-1",
      "seat_type": "U.S. Representative",
      "state": "Arizona",
      "county": "Maricopa County",
      "population": 1000000,
      "notes": "Highly competitive urban district."
    },
    {
      "district": "AZ-2",
      "seat_type": "U.S. Representative",
      "state": "Arizona",
      "county": "Pima County",
      "population": 600000,
      "notes": "Competitive district in southern Arizona."
    }
  ],
  "Arkansas": [
    {
      "district": "AR-1",
      "seat_type": "U.S. Representative",
      "state": "Arkansas",
      "county": "Pulaski County",
      "population": 400000,
      "notes": "Competitive district around Little Rock."
    },
    {
      "district": "AR-2",
      "seat_type": "U.S. Representative",
      "state": "Arkansas",
      "county": "Benton County",
      "population": 250000,
      "notes": "Suburban district with shifting trends."
    }
  ],
  "California": [
    {
      "district": "CA-1",
      "seat_type": "U.S. Representative",
      "state": "California",
      "county": "Los Angeles County",
      "population": 1500000,
      "notes": "Major urban district in LA."
    },
    {
      "district": "CA-2",
      "seat_type": "U.S. Representative",
      "state": "California",
      "county": "San Diego County",
      "population": 800000,
      "notes": "Competitive coastal district."
    }
  ],
  "Colorado": [
    {
      "district": "CO-1",
      "seat_type": "U.S. Representative",
      "state": "Colorado",
      "county": "Denver County",
      "population": 400000,
      "notes": "Urban district in Denver."
    },
    {
      "district": "CO-2",
      "seat_type": "U.S. Representative",
      "state": "Colorado",
      "county": "El Paso County",
      "population": 350000,
      "notes": "Competitive suburban district."
    }
  ],
  "Connecticut": [
    {
      "district": "CT-1",
      "seat_type": "U.S. Representative",
      "state": "Connecticut",
      "county": "Fairfield County",
      "population": 500000,
      "notes": "Competitive district in Bridgeport area."
    },
    {
      "district": "CT-2",
      "seat_type": "U.S. Representative",
      "state": "Connecticut",
      "county": "Hartford County",
      "population": 400000,
      "notes": "Suburban district around Hartford."
    }
  ],
  "Delaware": [
    {
      "district": "DE-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Delaware",
      "county": "New Castle County",
      "population": 250000,
      "notes": "Statewide at-large district."
    }
  ],
  "Florida": [
    {
      "district": "FL-1",
      "seat_type": "U.S. Representative",
      "state": "Florida",
      "county": "Miami-Dade County",
      "population": 1200000,
      "notes": "Competitive urban district."
    },
    {
      "district": "FL-2",
      "seat_type": "U.S. Representative",
      "state": "Florida",
      "county": "Broward County",
      "population": 800000,
      "notes": "Key suburban district."
    }
  ],
  "Georgia": [
    {
      "district": "GA-1",
      "seat_type": "U.S. Representative",
      "state": "Georgia",
      "county": "Fulton County",
      "population": 900000,
      "notes": "Competitive district in Atlanta."
    },
    {
      "district": "GA-2",
      "seat_type": "U.S. Representative",
      "state": "Georgia",
      "county": "Gwinnett County",
      "population": 700000,
      "notes": "Rapidly diversifying suburban district."
    }
  ],
  "Hawaii": [
    {
      "district": "HI-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Hawaii",
      "county": "Honolulu County",
      "population": 300000,
      "notes": "Statewide at-large district."
    }
  ],
  "Idaho": [
    {
      "district": "ID-1",
      "seat_type": "U.S. Representative",
      "state": "Idaho",
      "county": "Ada County",
      "population": 200000,
      "notes": "Competitive district in the Boise area."
    }
  ],
  "Illinois": [
    {
      "district": "IL-1",
      "seat_type": "U.S. Representative",
      "state": "Illinois",
      "county": "Cook County",
      "population": 1500000,
      "notes": "Major urban district in Chicago."
    },
    {
      "district": "IL-2",
      "seat_type": "U.S. Representative",
      "state": "Illinois",
      "county": "DuPage County",
      "population": 700000,
      "notes": "Suburban district with competitive trends."
    }
  ],
  "Indiana": [
    {
      "district": "IN-1",
      "seat_type": "U.S. Representative",
      "state": "Indiana",
      "county": "Marion County",
      "population": 400000,
      "notes": "Competitive district in Indianapolis."
    },
    {
      "district": "IN-2",
      "seat_type": "U.S. Representative",
      "state": "Indiana",
      "county": "Allen County",
      "population": 250000,
      "notes": "Suburban district in the Fort Wayne area."
    }
  ],
  "Iowa": [
    {
      "district": "IA-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Iowa",
      "county": "Polk County",
      "population": 300000,
      "notes": "Statewide at-large district."
    }
  ],
  "Kansas": [
    {
      "district": "KS-1",
      "seat_type": "U.S. Representative",
      "state": "Kansas",
      "county": "Sedgwick County",
      "population": 400000,
      "notes": "Urban district in Wichita."
    },
    {
      "district": "KS-2",
      "seat_type": "U.S. Representative",
      "state": "Kansas",
      "county": "Johnson County",
      "population": 350000,
      "notes": "Suburban district in Overland Park."
    }
  ],
  "Kentucky": [
    {
      "district": "KY-1",
      "seat_type": "U.S. Representative",
      "state": "Kentucky",
      "county": "Jefferson County",
      "population": 400000,
      "notes": "Competitive district in Louisville."
    },
    {
      "district": "KY-2",
      "seat_type": "U.S. Representative",
      "state": "Kentucky",
      "county": "Fayette County",
      "population": 250000,
      "notes": "District centered on Lexington."
    }
  ],
  "Louisiana": [
    {
      "district": "LA-1",
      "seat_type": "U.S. Representative",
      "state": "Louisiana",
      "county": "Orleans Parish",
      "population": 300000,
      "notes": "Competitive district in New Orleans."
    },
    {
      "district": "LA-2",
      "seat_type": "U.S. Representative",
      "state": "Louisiana",
      "county": "East Baton Rouge Parish",
      "population": 250000,
      "notes": "District covering the capital region."
    }
  ],
  "Maine": [
    {
      "district": "ME-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Maine",
      "county": "Cumberland County",
      "population": 120000,
      "notes": "Statewide at-large district."
    }
  ],
  "Maryland": [
    {
      "district": "MD-1",
      "seat_type": "U.S. Representative",
      "state": "Maryland",
      "county": "Montgomery County",
      "population": 800000,
      "notes": "Competitive urban/suburban district."
    },
    {
      "district": "MD-2",
      "seat_type": "U.S. Representative",
      "state": "Maryland",
      "county": "Prince George's County",
      "population": 600000,
      "notes": "Diverse and competitive."
    }
  ],
  "Massachusetts": [
    {
      "district": "MA-1",
      "seat_type": "U.S. Representative",
      "state": "Massachusetts",
      "county": "Suffolk County",
      "population": 700000,
      "notes": "Urban district in Boston."
    },
    {
      "district": "MA-2",
      "seat_type": "U.S. Representative",
      "state": "Massachusetts",
      "county": "Middlesex County",
      "population": 500000,
      "notes": "Suburban district with strong competition."
    }
  ],
  "Michigan": [
    {
      "district": "MI-1",
      "seat_type": "U.S. Representative",
      "state": "Michigan",
      "county": "Wayne County",
      "population": 800000,
      "notes": "Competitive district in Detroit."
    },
    {
      "district": "MI-2",
      "seat_type": "U.S. Representative",
      "state": "Michigan",
      "county": "Oakland County",
      "population": 600000,
      "notes": "Suburban swing district."
    }
  ],
  "Minnesota": [
    {
      "district": "MN-1",
      "seat_type": "U.S. Representative",
      "state": "Minnesota",
      "county": "Hennepin County",
      "population": 700000,
      "notes": "Urban district in Minneapolis."
    },
    {
      "district": "MN-2",
      "seat_type": "U.S. Representative",
      "state": "Minnesota",
      "county": "Ramsey County",
      "population": 400000,
      "notes": "District covering the St. Paul area."
    }
  ],
  "Mississippi": [
    {
      "district": "MS-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Mississippi",
      "county": "Hinds County",
      "population": 250000,
      "notes": "Statewide at-large district."
    }
  ],
  "Missouri": [
    {
      "district": "MO-1",
      "seat_type": "U.S. Representative",
      "state": "Missouri",
      "county": "St. Louis County",
      "population": 700000,
      "notes": "Urban district in St. Louis."
    },
    {
      "district": "MO-2",
      "seat_type": "U.S. Representative",
      "state": "Missouri",
      "county": "Jackson County",
      "population": 500000,
      "notes": "Suburban district around Kansas City."
    }
  ],
  "Montana": [
    {
      "district": "MT-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Montana",
      "county": "Yellowstone County",
      "population": 120000,
      "notes": "Statewide at-large district."
    }
  ],
  "Nebraska": [
    {
      "district": "NE-1",
      "seat_type": "U.S. Representative",
      "state": "Nebraska",
      "county": "Douglas County",
      "population": 400000,
      "notes": "Competitive urban district in Omaha."
    },
    {
      "district": "NE-2",
      "seat_type": "U.S. Representative",
      "state": "Nebraska",
      "county": "Lancaster County",
      "population": 250000,
      "notes": "District around Lincoln."
    }
  ],
  "Nevada": [
    {
      "district": "NV-1",
      "seat_type": "U.S. Representative",
      "state": "Nevada",
      "county": "Clark County",
      "population": 1200000,
      "notes": "Major urban district in Las Vegas."
    }
  ],
  "New Hampshire": [
    {
      "district": "NH-At-Large",
      "seat_type": "U.S. Representative",
      "state": "New Hampshire",
      "county": "Hillsborough County",
      "population": 150000,
      "notes": "Statewide at-large district."
    }
  ],
  "New Jersey": [
    {
      "district": "NJ-1",
      "seat_type": "U.S. Representative",
      "state": "New Jersey",
      "county": "Essex County",
      "population": 900000,
      "notes": "Competitive district in Newark area."
    },
    {
      "district": "NJ-2",
      "seat_type": "U.S. Representative",
      "state": "New Jersey",
      "county": "Hudson County",
      "population": 700000,
      "notes": "Suburban district in northern NJ."
    }
  ],
  "New Mexico": [
    {
      "district": "NM-At-Large",
      "seat_type": "U.S. Representative",
      "state": "New Mexico",
      "county": "Bernalillo County",
      "population": 250000,
      "notes": "Statewide at-large district."
    }
  ],
  "New York": [
    {
      "district": "NY-1",
      "seat_type": "U.S. Representative",
      "state": "New York",
      "county": "New York County",
      "population": 1500000,
      "notes": "Competitive urban district in Manhattan."
    },
    {
      "district": "NY-2",
      "seat_type": "U.S. Representative",
      "state": "New York",
      "county": "Kings County",
      "population": 1200000,
      "notes": "Diverse district in Brooklyn."
    }
  ],
  "North Carolina": [
    {
      "district": "NC-1",
      "seat_type": "U.S. Representative",
      "state": "North Carolina",
      "county": "Mecklenburg County",
      "population": 800000,
      "notes": "Urban district in Charlotte."
    },
    {
      "district": "NC-2",
      "seat_type": "U.S. Representative",
      "state": "North Carolina",
      "county": "Wake County",
      "population": 600000,
      "notes": "District covering the Raleigh area."
    }
  ],
  "North Dakota": [
    {
      "district": "ND-At-Large",
      "seat_type": "U.S. Representative",
      "state": "North Dakota",
      "county": "Cass County",
      "population": 100000,
      "notes": "Statewide at-large district."
    }
  ],
  "Ohio": [
    {
      "district": "OH-1",
      "seat_type": "U.S. Representative",
      "state": "Ohio",
      "county": "Cuyahoga County",
      "population": 1000000,
      "notes": "Urban district in Cleveland."
    },
    {
      "district": "OH-2",
      "seat_type": "U.S. Representative",
      "state": "Ohio",
      "county": "Franklin County",
      "population": 900000,
      "notes": "District covering Columbus."
    }
  ],
  "Oklahoma": [
    {
      "district": "OK-1",
      "seat_type": "U.S. Representative",
      "state": "Oklahoma",
      "county": "Oklahoma County",
      "population": 400000,
      "notes": "Urban district in Oklahoma City."
    }
  ],
  "Oregon": [
    {
      "district": "OR-1",
      "seat_type": "U.S. Representative",
      "state": "Oregon",
      "county": "Multnomah County",
      "population": 700000,
      "notes": "Competitive district in Portland."
    }
  ],
  "Pennsylvania": [
    {
      "district": "PA-1",
      "seat_type": "U.S. Representative",
      "state": "Pennsylvania",
      "county": "Philadelphia County",
      "population": 1000000,
      "notes": "Urban district in Philadelphia."
    },
    {
      "district": "PA-2",
      "seat_type": "U.S. Representative",
      "state": "Pennsylvania",
      "county": "Allegheny County",
      "population": 600000,
      "notes": "District covering Pittsburgh."
    }
  ],
  "Rhode Island": [
    {
      "district": "RI-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Rhode Island",
      "county": "Providence County",
      "population": 150000,
      "notes": "Statewide at-large district."
    }
  ],
  "South Carolina": [
    {
      "district": "SC-1",
      "seat_type": "U.S. Representative",
      "state": "South Carolina",
      "county": "Charleston County",
      "population": 350000,
      "notes": "Competitive coastal district."
    },
    {
      "district": "SC-2",
      "seat_type": "U.S. Representative",
      "state": "South Carolina",
      "county": "Greenville County",
      "population": 300000,
      "notes": "District covering upstate regions."
    }
  ],
  "South Dakota": [
    {
      "district": "SD-At-Large",
      "seat_type": "U.S. Representative",
      "state": "South Dakota",
      "county": "Minnehaha County",
      "population": 120000,
      "notes": "Statewide at-large district."
    }
  ],
  "Tennessee": [
    {
      "district": "TN-1",
      "seat_type": "U.S. Representative",
      "state": "Tennessee",
      "county": "Shelby County",
      "population": 500000,
      "notes": "Competitive district in Memphis."
    },
    {
      "district": "TN-2",
      "seat_type": "U.S. Representative",
      "state": "Tennessee",
      "county": "Davidson County",
      "population": 400000,
      "notes": "District covering Nashville."
    }
  ],
  "Texas": [
    {
      "district": "TX-1",
      "seat_type": "U.S. Representative",
      "state": "Texas",
      "county": "Harris County",
      "population": 1500000,
      "notes": "Major urban district in Houston."
    },
    {
      "district": "TX-2",
      "seat_type": "U.S. Representative",
      "state": "Texas",
      "county": "Dallas County",
      "population": 1200000,
      "notes": "Competitive district in Dallas."
    }
  ],
  "Utah": [
    {
      "district": "UT-1",
      "seat_type": "U.S. Representative",
      "state": "Utah",
      "county": "Salt Lake County",
      "population": 500000,
      "notes": "Urban district in Salt Lake City."
    }
  ],
  "Vermont": [
    {
      "district": "VT-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Vermont",
      "county": "Chittenden County",
      "population": 80000,
      "notes": "Statewide at-large district."
    }
  ],
  "Virginia": [
    {
      "district": "VA-1",
      "seat_type": "U.S. Representative",
      "state": "Virginia",
      "county": "Fairfax County",
      "population": 700000,
      "notes": "Competitive district in Northern Virginia."
    },
    {
      "district": "VA-2",
      "seat_type": "U.S. Representative",
      "state": "Virginia",
      "county": "Prince William County",
      "population": 500000,
      "notes": "Rapidly growing suburban district."
    }
  ],
  "Washington": [
    {
      "district": "WA-1",
      "seat_type": "U.S. Representative",
      "state": "Washington",
      "county": "King County",
      "population": 1200000,
      "notes": "Urban district in Seattle."
    }
  ],
  "West Virginia": [
    {
      "district": "WV-At-Large",
      "seat_type": "U.S. Representative",
      "state": "West Virginia",
      "county": "Kanawha County",
      "population": 100000,
      "notes": "Statewide at-large district."
    }
  ],
  "Wisconsin": [
    {
      "district": "WI-1",
      "seat_type": "U.S. Representative",
      "state": "Wisconsin",
      "county": "Milwaukee County",
      "population": 800000,
      "notes": "Urban district in Milwaukee."
    },
    {
      "district": "WI-2",
      "seat_type": "U.S. Representative",
      "state": "Wisconsin",
      "county": "Dane County",
      "population": 500000,
      "notes": "District covering the Madison area."
    }
  ],
  "Wyoming": [
    {
      "district": "WY-At-Large",
      "seat_type": "U.S. Representative",
      "state": "Wyoming",
      "county": "Laramie County",
      "population": 60000,
      "notes": "Statewide at-large district."
    }
  ]
};